module.exports = __webpack_public_path__ + "static/media/Bodoni-FLF.80c0e9b6.svg";